module.exports = __webpack_public_path__ + "static/media/brand-icons.c5ebe0b3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/brand-icons.ttf
// module id = 4414
// module chunks = 0